import { render, staticRenderFns } from "./TabPromotionContent.vue?vue&type=template&id=8a93cce8"
import script from "./TabPromotionContent.vue?vue&type=script&lang=js"
export * from "./TabPromotionContent.vue?vue&type=script&lang=js"
import style0 from "./TabPromotionContent.vue?vue&type=style&index=0&id=8a93cce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports